// @flow
import React, { useState } from 'react';
import classNames from '@ta/common.classnames';
import { Interval } from '@ta/common.timer';
import SavesCard from './SavesCardAnimation';
import styles from './SavesCarouselAnimation.css';

const imagePath0 = '/img2/cx/explicit_preferences/savesCard1.png';
const imagePath1 = '/img2/cx/explicit_preferences/savesCard2.png';
const imagePath2 = '/img2/cx/explicit_preferences/savesCard3.png';

/**
 * Animation for Saves Educator Version of the End Screen
 * Three rotating saves cards with an animation emphasize selecting the heart save icon.
 *
 * @author: agibner
 * At least 5 cards are needed for this carousel animation implementation to work.
 * The animation is a result of cards transitioning between 5 possible different styling positions:
 *      offLeft, left, selected, right, offRight
 * (Since there are only three cards we wanted visible, I added two duplicates to apply styling to)
 */
const SavesCarouselAnimation = () => {
  const items = [imagePath0, imagePath1, imagePath2];
  const [step, setStep] = useState(0);

  const transitionCards = () => {
    if (step < 2) {
      setStep(step + 1);
    }
  };

  return (
    <React.Fragment>
      <Interval interval={1500} callback={transitionCards} />
      <div className={styles.carousel}>
        <div className={styles.cards}>
          {/* B' (position: offLeft -> offRight -> right) */}

          <span
            className={classNames(styles.imageContainer, {
              [styles.offLeft]: step === 0,
              [styles.offRight]: step === 1,
              [styles.right]: step === 2,
            })}
          >
            {' '}
            <SavesCard imagePath={items[1]} active={false} filled={step >= 0} />
          </span>

          {/* A (position: left -> offLeft -> offRight) */}

          <span
            className={classNames(styles.imageContainer, {
              [styles.left]: step === 0,
              [styles.offLeft]: step === 1,
              [styles.offRight]: step === 2,
            })}
          >
            <SavesCard imagePath={items[0]} active={false} filled={step > 1} />
          </span>

          {/* B (position: selected -> left -> offLeft) */}
          <span
            className={classNames(styles.imageContainer, {
              [styles.selected]: step === 0,
              [styles.left]: step === 1,
              [styles.offLeft]: step === 2,
            })}
          >
            {' '}
            <SavesCard imagePath={items[1]} active={step === 0} filled={step >= 0} />
          </span>

          {/* C (position: right -> selected -> left) */}

          <span
            className={classNames(styles.imageContainer, {
              [styles.right]: step === 0,
              [styles.selected]: step === 1,
              [styles.left]: step === 2,
            })}
          >
            <SavesCard imagePath={items[2]} active={step === 1} filled={step > 0} />
          </span>

          {/* A' (position: offRight -> right -> selected) */}
          <span
            className={classNames(styles.imageContainer, {
              [styles.offRight]: step === 0,
              [styles.right]: step === 1,
              [styles.selected]: step === 2,
            })}
          >
            <SavesCard imagePath={items[0]} active={step === 2} filled={step > 1} />
          </span>
        </div>
      </div>
    </React.Fragment>
  );
};

export default SavesCarouselAnimation;
